import evn from './env';

const common = {
  imageUri: process.env.REACT_APP_BK_BASE_URL,
};

const development = {
  endPointAdmin: process.env.REACT_APP_BK_BASE_URL,
};

const production = {
  endPointAdmin: process.env.REACT_APP_BK_BASE_URL,
  // endPointAdmin: 'http://185.211.57.54',
};

export default {
  ...common,
  ...evn(
    () => production,
    () => development
  ),
};
